import {
  SwapIcon_default
} from "./chunk-F4UAQHFT.mjs";
export {
  SwapIcon_default as default
};
